export default __webpack_public_path__ + "static/media/17-impact-effort-analysis.2943cb2b.svg";